import { datadogRum } from '@datadog/browser-rum';

export const isValidPlanId = (planId?: string) => {
  if (!planId) {
    return false;
  }

  const isValid =
    /^crn:pathway:plan:[a-zA-Z0-9]{26}$/.test(planId) ||
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
      planId,
    );

  if (!isValid) {
    datadogRum.addError(new Error(`Invalid planId detected: ${planId}!`));
  }

  return isValid;
};
